import actions from './actions'

const initialState = {
  active: [],
  aiList: [],
  botsList: [],
  botsActive: [],
  botsListTotal: 0,
  botsListPagination: {},
  personalitiesList: [],
  personalitiesActive: [],
  personalitiesListTotal: 0,
  personalitiesListPagination: {},
  settingsActive: [],
  loading: false,
}

export default function aiReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
